import { ProductTypeDefinition, ProductTypeOrCategoryDefinition, ProductsCategoryDefinition } from '../types/ProductTypeFrontendDefinition';

export const isCategory = (product: ProductTypeOrCategoryDefinition): product is ProductsCategoryDefinition => 'productTypes' in product;
export const notIsCategory = (product: ProductTypeOrCategoryDefinition): product is ProductTypeDefinition => !('productTypes' in product);
